"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchContactLists = exports.FetchContactListsActionTypes = exports.fetchContactLists = exports.ContactListsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var ContactListsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_CONTACT_LISTS: null
}, _constants.CONTACT_LISTS);
exports.ContactListsActionTypes = ContactListsActionTypes;
var fetchContactLists = (0, _fluxActions.createAction)(ContactListsActionTypes.FETCH_CONTACT_LISTS);
exports.fetchContactLists = fetchContactLists;
var FetchContactListsActionTypes = (0, _actions.createRequestTypes)(ContactListsActionTypes.FETCH_CONTACT_LISTS);
exports.FetchContactListsActionTypes = FetchContactListsActionTypes;
var FetchContactLists = (0, _actions.createRequestActions)(FetchContactListsActionTypes);
exports.FetchContactLists = FetchContactLists;